module.exports = __webpack_public_path__ + "img/_dsc8182.bc39fb60.jpg";